import React from 'react';
import { motion } from 'framer-motion';
export function CreatorSection() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.8
  }} className="py-16 lg:py-20 border-t border-[#1B6B3A]/10" data-id="element-17">
      <div className="max-w-2xl mx-auto px-6 text-center" data-id="element-18">
        <p className="text-xs font-bold tracking-widest text-[#1B6B3A] uppercase mb-4" data-id="element-19">
          About the Creators
        </p>

        <p className="text-base lg:text-lg text-[#3D3D3D] leading-relaxed font-serif italic" data-id="element-20">
          "Closing Number Lock was built by a team that watched too many buyers
          get blindsided at the closing table. After seeing the same
          coordination failures repeat — insurance quotes arriving late, tax
          prorations shifting, wire instructions changing — we built the system
          we wished every buyer had. This isn't theory. It's a process born from
          real closings."
        </p>
      </div>
    </motion.section>;
}